import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#6F7171",
      d: "M2.294 3.71a1 1 0 0 1 1.414-1.415l6.296 6.297 6.288-6.282a1 1 0 0 1 1.414 1.415l-6.288 6.281 6.288 6.287a1 1 0 1 1-1.414 1.414l-6.29-6.288-6.294 6.288a1 1 0 0 1-1.414-1.414l6.295-6.288z"
    }, null, -1)
  ]))]))
}
export default { render: render }